import React from "react";
import BatchDetails from "../components/PaymentBatches/BatchDetails";

const BatchDetailsPage: React.FC = () => {
  return (
    <>
      <BatchDetails />
    </>
  );
};

export default BatchDetailsPage;
